// Written in this round about way for babel-transform-imports
import withRouter from 'react-router/es/withRouter';

export default withRouter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.4.2.2@react-router-dom/es/withRouter.js
// module id = 515
// module chunks = 1